import React, { useState } from 'react';
import { DEVICES_EDIT } from '../../../../constants/DeviceConst';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import { getUserLevel } from '../../../../utils/RBACUtil';
import ConfigurationsDeviceViewDetail from './Device-View-Details';

const DevicesView = (props) => {
  const { device, toggleDrawer, onViewToggle, hotelId } = props;
  const [tabValue, setTabValue] = useState(0);
  const DEVICE_TABS = ['Details', 'Channels'];
  const [userRole, setUserRole] = useState('');

  (async () => {
    try {
      const role = await getUserLevel();
      setUserRole(role);
    } catch (e) {
      console.error('User role retrieval failed');
    }
  })();

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, device);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(DEVICES_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <ConfigurationsDeviceViewDetail tabValue={tabValue} device={device} hotelId={hotelId} />;
  };

  return (
    <div>
      <DetailViewLayout
        onClickEdit={onClickEdit}
        renderScreen={renderScreen}
        onViewToggle={onViewToggle}
        handleTabChange={handleTabChange}
        tabValue={tabValue}
        tabList={DEVICE_TABS}
        title={device.area_type_value}
        isEditable={userRole === 'Super Admin'}
        tabClass='col-md-4'
      />
    </div>
  );
};

export default DevicesView;
